import { useEffect, useState } from 'react';
import { isNil } from 'ramda';
import loadTcVars from '@@app/extra/loadTcVars';

const useInit = (dataInit) => {
  const [provider, setProvider] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const { parcours_type, user_id, reprise_parcours, organisme } = dataInit;

  const loadScript = (src) => {
    if (!isNil(src)) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = () => {
          setLoaded(true);
        };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
  };

  const initGTM = async (containerId) => {
    if (!isNil(containerId)) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      const script = document.createElement('script');
      script.async = true;
      script.id = 'gtm-script';
      script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
      document.head.appendChild(script);

      return new Promise((resolve, reject) => {
        script.onload = () => {
          setLoaded(true);
        };
        script.onerror = reject;
      });
    }
  };

  const initTagCommander = async (src) => {
    loadTcVars({
      parcours_type,
      user_id,
      reprise_parcours,
      organisme
    });
    await loadScript(src);
    return Promise.resolve();
  };

  useEffect(() => {
    const init = async () => {
      const response = await fetch('/config/analytics');
      const { data } = await response.json();

      setProvider(data.provider);

      try {
        switch (data.provider) {
          case 'gtm':
            await initGTM(data.gtm.containerId);
            break;
          case 'tagcommander':
            await initTagCommander(data.tagcommander.src);
            break;
          default:
            console.warn('Aucun provider configuré');
        }
      } catch (err) {
        console.error('Erreur lors de l\'initialisation du provider analytics', err);
      }
    };

    init();
  }, [dataInit]);

  return {
    provider,
    loaded
  };
};

export default useInit;
